import * as yup from 'yup';

export const evermartSchema = yup.object().shape({
  account_id: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(24, 'Informe um account id válido.')
    .max(200, 'Informe um account id válido.'),
});
